export const initialNftTransactionStatus = {
  timer: "",
  status: "",
  success: "",
}
export const initialSaveVideoCollectionState = {
  publish: 1,
  link: [],
  aiFiles: [],
  dataFields: [],
  nftAuth: [],
  nftAuthOffchain: [],
  image: "",
  title: "",
  desc: "",
  mdxEditorPos: null,
  eventSendId: null,
  eventEditorId: "",
  eventSendMessage: [],
  eventSendIcon: "Article",
  eventSendTemplate: "custom",
  eventSendCategory: "",
  eventSendDateAttestation: "",
  manualContractAddr: "",
  manualTokenId: "",
  manualTokenIdMin: "",
  manualTokenIdMax: "",
  manualNetwork: "mainnet",
  plannerCategorySelected: "rawmaterials",
  plannerAttributesSelected: [],
  plannerProductMedia: {},
  plannerEditorId: "",
  displayTitle: true,
  tokenConfigData: {
    id: "",
    network: "",
    contract: "",
    tokenid: "",
    title: "",
    media: "",
  },
  tokenConfigSortOrder: "none",
  tokenConfigDisplayCategory: 0,
  tokenConfigDisplayCategorySub: 1,
  tokenCollectionImageTile: "cover",
  tokenCollectionPosterPos: null,
  imageMarqueeChanged: false,
  imageMarqueeSrc: "",
  currentMdxEditor: "",
  errorGenerate: {},
  generativeCredits: {},
  generativeLastRefineId: "",
  generativeLastRawResponse: "",
  genAiOptionWordCount: 75,
  genAiOptionTemp: 1,
  genAiFreqPenalty: 0,
}

export const initialState = {
  forms: {
    notify: { media: [] },
    saveVideoCollection: initialSaveVideoCollectionState,
    saveimage: {},
    deleteimage: [],
    deleteimagefiles: [],
    tag: {},
    workingtags: [],
    userdetail: {},
    userdetailemail: {
      email: "",
      mobile: "",
      verifycode: "",
      displayname: "",
      error: "",
    },
    plannerTemplateSaveData: {},
    qrcode: {
      colordots: "#000000", //black
      colorbg: "#00000000", //transparent
    },
  },
  isLoadingImageUpload: false,
  isLoadingImageDelete: false,
  imageuploadprogress: {},
  imagelibrary: "userupload",
  imagetags: [],
  isLoading: false,
  isLoadingMediaUpdate: false,
  isLoadingTokenConfig: false,
  isLoadingNotifyCreate: false,
  isLoadingPlannerGenerate: 0,
  isLoadingUserNfts: false,
  isLoadingVideoCollectionsList: false,
  notify: [],
  isLoadingTemplateCreate: false,
  isLoadingTemplateFetch: false,
  publisher: {
    mode: "image",
    templates: [],
  },
  loginMessage: "",
  emailVerifyMode: false,
  userdetail: {},
  userdetailemail: {
    email: "",
    mobile: "",
    verifycode: "",
  },
  userlogin: {},
  usersub: "",
  company: {},
  isProfileUpdateComplete: false,
  isLoadingUserGroup: false,
  userGroupUpdateComplete: false,
  loginCurrentStatus: "",
  loginSuspended: [],
  gettingStartedPos: 0,
  gettingStartedModule: "",
  permissionMembers: [],
  isLoadingCollectionCreate: false,
  collectionPosts: [],
  videoStatusDeleteVideoMessage: [],
  isLoadingVideoRenderList: false,
  videoRenderList: [],
  videoStatusRecheckActive: false,
  videoStatusRecheckCounter: 0,
  videoRenderCurrentStatus: {},
  plannerTemplates: [],
  eventAccessRoles: [],
  eventAccessRoleCreateComplete: false,
  eventAccessRolesError: null,
  mintingItem: {},
  userNfts: [],
  userNftsAlchemy: [],
  walletAddress: "",
  walletChainId: null,
  walletProvider: "",
  walletStatus: false,
  walletWeb3: null,
  walletSigner: null,
  nftTransactionStatus: initialNftTransactionStatus,
  manualTokenMetadata: {},
  platformSettings: { catOverride: [], catCustom: [] },
  platformSettingsSaveSuccess: false,
  offchainOptions: {
    mintOffchain: false,
    eventOffchain: false,
    plannerOffchain: false,
  },
  reportingCollectionsItemGroup: [],
  isNewPlannerAttribute: null,
  attributeFilter: null,
}
